import { render, staticRenderFns } from "./UserClaimForm.vue?vue&type=template&id=082018aa"
import script from "./UserClaimForm.vue?vue&type=script&lang=js"
export * from "./UserClaimForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('082018aa')) {
      api.createRecord('082018aa', component.options)
    } else {
      api.reload('082018aa', component.options)
    }
    module.hot.accept("./UserClaimForm.vue?vue&type=template&id=082018aa", function () {
      api.rerender('082018aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsTeam/UserClaimForm.vue"
export default component.exports